import { guid } from "../utils";

const tracr_ANONYMOUS_ID_KEY = "tracr_anonymous_id";
const tracr_IS_ANONYMOUSID_NEW = "tracr_is_anonymousid_new";
const tracr_SESSION_ID_KEY = "tracr_session_id";

const metadata = {
  generateAnonymousId() {
    const anonymous_id = guid();
    localStorage.setItem(tracr_ANONYMOUS_ID_KEY, anonymous_id);
    sessionStorage.setItem(tracr_IS_ANONYMOUSID_NEW, true);

    return anonymous_id;
  },

  getAnonymousId() {
    const anonymous_id =
      localStorage.getItem(tracr_ANONYMOUS_ID_KEY) ||
      metadata.generateAnonymousId();

    return anonymous_id;
  },

  getIsAnonymousIdNew() {
    return sessionStorage.getItem(tracr_IS_ANONYMOUSID_NEW) === "true";
  },

  getSessionId() {
    const session_id =
      sessionStorage.getItem(tracr_SESSION_ID_KEY) ||
      metadata.generateSessionId();

    return session_id;
  },

  generateSessionId() {
    const session_id = guid();
    sessionStorage.setItem(tracr_SESSION_ID_KEY, session_id);

    return session_id;
  },
};

export default metadata;
